import { Component, Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { take } from 'rxjs/operators';
import { SecurityPolicies } from '../services/auth-variables';
import { AuthService } from '../services/auth.service';
import { LogService } from '../services/log.service';

@Directive({
  selector: '[appAuthorization]',
})
export class AuthorizationDirective implements OnInit {
  @Input() policy: SecurityPolicies| SecurityPolicies[] | null;
  @Input() policyOptions: { policyAction?: 'Hide' | 'Disable', componentRef?: Component};

  constructor(
    private eleRef: ElementRef,
    private renderer: Renderer2,
    private logger: LogService,
    private authService: AuthService,
  ) {}

  private failedPolicyCheck?: boolean = false;

  ngOnInit(): void {

    //return when policy was not passed in.
    // dynamic list items may not always pass in a policy and if so would be visible w/no security
    //applied
    if (!this.policy) return;

    this.hideControl();

    //if policy is an array, check each policy
    if (Array.isArray(this.policy)) {
      this.policy.forEach((policy) => {
        if(this.failedPolicyCheck === true)
          return;

          this.checkPolicy(policy);

        });
      return;
    }
    this.checkPolicy(this.policy);

  }
  private checkPolicy(policy: SecurityPolicies) {

    this.authService
      .passesPolicyOf(policy)
      .pipe(take(1))
      .subscribe((policyPassed) => {
        if (this.policyOptions?.policyAction === 'Disable') {
          this.showControl();
          if (!policyPassed){
            this.failedPolicyCheck = true;
            this.disableControl();
          }
          return;
        } else {
          if (policyPassed){
            this.showControl();
          }
          return;
        }
      });

  }

  private disableControl() {
    let htmlElement: HTMLInputElement = this.eleRef.nativeElement;
    htmlElement.disabled = true;

    if(this.policyOptions?.componentRef){
      this.policyOptions.componentRef['disabled'] = true;
    }

  }

  private showControl() {
    let htmlElement: HTMLElement = this.eleRef.nativeElement;
    htmlElement.style.display = null;
  }

  private hideControl() {
    let htmlElement: HTMLElement = this.eleRef.nativeElement;
    htmlElement.style.display = 'none';
  }
}
